export function createSlug(str) {
  return str
    .trim()
    .toLowerCase()
    .split(" ")
    .join("-");
}

export function verifySlugRecipe(title, dataset) {
  const slug = createSlug(title);
  const matches = dataset.filter(recipe => recipe.slug === slug);
  if (matches.length) return true;
  return false;
}

export function verifyChars(str) {
  const regx = /[^a-z0-9 ]+/g;
  return regx.exec(str.toLowerCase());
}
